import { useJobStatus } from '@/api/Jobs';
import { AppRoutes } from '@/routes';
import {
  faBarsProgress,
  JobChainDetail,
  PageContainer,
  Title,
} from '@/ui/components';
import { Alert, Button, Card, Spin } from 'antd';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';

export const JobChainDetailPage = () => {
  const { jobChainId: jobChainIdParam } = useParams<{
    jobChainId: string;
  }>();
  const jobChainId = Number(jobChainIdParam);
  const isValidJobChainId = Number.isInteger(jobChainId) && jobChainId > 0;
  const {
    data: jobStatus,
    isLoading: isJobStatusLoading,
    isError: isJobStatusError,
    refetch: refetchJobStatus,
  } = useJobStatus();

  const detailJobStatus = useMemo(
    () =>
      (
        jobStatus?.filter((status) => status.name !== 'CancelledBySystem') || []
      ).map((status) => ({
        jobStatusId: status.jobStatusId,
        name: status.name,
        description:
          status.name === 'CancelledByUser'
            ? 'Cancelled'
            : status.description || status.name,
      })),
    [jobStatus],
  );

  return (
    <PageContainer>
      <Title title="Job Chain Detail" icon={faBarsProgress} />
      <Card
        extra={<Link to={AppRoutes.jobs}>Back to Job Chains</Link>}
        styles={{ body: { padding: 16 } }}
      >
        {!isValidJobChainId ? (
          <Alert type="error" showIcon message="Invalid Job Chain ID." />
        ) : isJobStatusError ? (
          <Alert
            type="error"
            showIcon
            message="Job status options could not be loaded."
            action={
              <Button onClick={() => void refetchJobStatus()}>Retry</Button>
            }
          />
        ) : (
          <Spin spinning={isJobStatusLoading}>
            {!isJobStatusLoading && (
              <JobChainDetail
                jobChainId={jobChainId}
                jobStatus={detailJobStatus}
              />
            )}
          </Spin>
        )}
      </Card>
    </PageContainer>
  );
};
